/**
 * Created by smizrahi on 8/18/16.
 */

export default class Manager {
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./js/core/managers/Manager.js